import { Activity, AlertTriangle, CheckCircle2, Circle } from "lucide-react";
import { SignalItem } from "../../lib/commandCore";

const toneMeta = {
  good: { icon: CheckCircle2, className: "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-400/25 dark:bg-emerald-400/10 dark:text-emerald-100" },
  watch: { icon: AlertTriangle, className: "border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-400/25 dark:bg-amber-400/10 dark:text-amber-100" },
  danger: { icon: AlertTriangle, className: "border-rose-200 bg-rose-50 text-rose-800 dark:border-rose-400/25 dark:bg-rose-400/10 dark:text-rose-100" },
  neutral: { icon: Circle, className: "border-border bg-bg text-muted dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300" },
};

export function SignalStrip({ signals }: { signals: SignalItem[] }) {
  return (
    <section className="command-card p-4">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h2 className="text-xl font-bold">判断材料</h2>
        </div>
        <Activity className="h-5 w-5 text-emerald-200" />
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {signals.map((signal) => {
          const meta = toneMeta[signal.tone];
          const Icon = meta.icon;
          return (
            <div key={signal.id} className={`rounded-md border p-3 ${meta.className}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-semibold opacity-80">{signal.label}</span>
                <span
                  title={signal.tone === "watch" || signal.tone === "danger" ? signal.detail : undefined}
                  aria-label={signal.tone === "watch" || signal.tone === "danger" ? signal.detail : undefined}
                  className="shrink-0"
                >
                  <Icon className="h-4 w-4" />
                </span>
              </div>
              <p className="mt-2 font-mono text-lg font-bold">{signal.value}</p>
              <p className="mt-1 break-words text-xs leading-relaxed opacity-80">{signal.detail}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
